module.exports = __webpack_public_path__ + "img/kilometer2.56a4ddb8.svg";